/**
 * Created by iosc on 2018/1/15.
 */

import React, {PureComponent} from 'react'
import './Advertisement.css'

class About extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			popup: false
		};

		this.key = 0;// 控制播放的张数
		this.timer = setInterval(this.autoplay, 6000);// 自动轮播
	}

	autoplay = () => {
		/*自动轮播时,要对播放的张数key进行一个判断,如果播放的张数超过ulLis.length-1,
		就要重头开始播放.  因为我们克隆了第一张并将其放在最后面,所以我们要从第二张图片开始播放*/
		this.liWidth = this.refs.list.children[0].offsetWidth;
		this.key += 1; // 先++
		if (this.key > this.refs.list.children.length - 1) {// 后判断
			this.refs.list.style.left = 0; // 迅速调回
			this.key = 0; // 因为第6张是第一张，所以播放的时候是从第2张开始播放
		}
		// // 动画部分
		this.animate(this.refs.list, -this.key * this.liWidth);
	};
	animate = (obj, target) => {
		// 首先清除掉定时器
		clearInterval(obj.timer);
		// 用来判断 是+ 还是 -  即说明向左走还是向右走
		var speed = obj.offsetLeft < target ? 15 : -15;
		obj.timer = setInterval(function () {
			var result = target - obj.offsetLeft;//它们的差值不会超过speed
			obj.style.left = obj.offsetLeft + speed + "px";
			// 有可能有小数的存在，所以在这里要做个判断
			if (Math.abs(result) <= Math.abs(speed)) {
				clearInterval(obj.timer);
				obj.style.left = target + "px";
			}
		}, 10);
	};

	popup = () => {
		this.setState({
			popup: !this.state.popup
		})
	};

	componentWillUnmount() {
		clearInterval(this.timer)
	}

	render() {
		return (
			<div>
				<img className="ADHeader" alt="introduction1" src={require('./images/advertisement1.jpg')}
						 onClick={this.popup}/>
				<div className="ADHeader-s" alt="introduction1"
						 style={{backgroundImage: `url('${require('./images/advertisement1.jpg')}')`}} onClick={this.popup}/>
				<a href="/points#normal"><img id="global" alt="home3" src={require('./images/advertisement2.jpg')}
																			style={{display: 'block', width: '100%'}}/></a>
				<div id="scroll" className="scroll">
					<img id="normal" alt="home3" src={require('./images/advertisement3.jpg')}
							 style={{display: 'block', width: '100%'}}/>
					<div id="box" className="box">
						<ul id="ul" ref="list" style={{width: '500%'}}>
							<li><img src={require('./images/advertisement31.jpg')} width="100%" style={{display: 'block'}}/></li>
							<li><img src={require('./images/advertisement32.jpg')} width="100%" style={{display: 'block'}}/></li>
							<li><img src={require('./images/advertisement33.jpg')} width="100%" style={{display: 'block'}}/></li>
							<li><img src={require('./images/advertisement34.jpg')} width="100%" style={{display: 'block'}}/></li>
							<li><img src={require('./images/advertisement35.jpg')} width="100%" style={{display: 'block'}}/></li>
						</ul>
					</div>
				</div>
				<a href="/points#train"><img id="train" alt="home3" src={require('./images/advertisement4.jpg')}
																		 style={{display: 'block', width: '100%'}}/></a>
				<img alt="home3" src={require('./images/advertisement5.jpg')} style={{display: 'block', width: '100%'}}/>
				{
					this.state.popup ? (
						<div style={{
							position: 'fixed',
							top: '0px',
							bottom: '0px',
							left: '0px',
							right: '0px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center'
						}} onClick={this.popup}>
							<img alt="home3" src={require('./images/ad-popup.png')}
									 style={{
										 display: 'block',
										 width: 1196 / 1920 * window.innerWidth + 'px',
										 height: 710 / 1920 * window.innerWidth + 'px'
									 }}/>
						</div>
					) : null
				}
			</div>
		)
	}
}

export default About


// WEBPACK FOOTER //
// ./src/Advertisement.js